import React, { FC } from 'react';
import { Moment } from 'moment';

import { useLang } from 'hooks';
import { useStatisticsVolumesQuery } from 'hooks/queries';

import CardView from './CardView';

type IncomingPaymentsCardProps = {
  dateFrom: Moment;
  dateTo: Moment;
};

const IncomingPaymentsCard: FC<IncomingPaymentsCardProps> = ({ dateFrom, dateTo }) => {
  const lang = useLang();

  const volumesQuery = useStatisticsVolumesQuery({ dateFrom, dateTo });

  return (
    <CardView
      title={lang.get('dashboard.card.incomingPayments')}
      amounts={volumesQuery.data?.map((volume) => ({
        date: volume.day,
        value: volume.input,
      })) ?? []}
      loading={volumesQuery.isLoading}
    />
  );
};

export default IncomingPaymentsCard;
